import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callFunction } from "../lib/api";
import { mapMatch, MatchRow } from "../lib/match";
import { Match } from "../types";

interface CreateMatchPayload {
  location: string;
  date: string;
  time: string;
  spotsNeeded: number;
  note?: string;
  names?: string[];
  userId?: string;
  userEmail?: string;
}

export const useCreateMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateMatchPayload): Promise<Match> => {
      const data = (await callFunction("/create-match", {
        method: "POST",
        body: JSON.stringify({
          location: payload.location,
          date: payload.date,
          time: payload.time,
          spotsNeeded: payload.spotsNeeded,
          note: payload.note,
          names: payload.names,
          userId: payload.userId,
          userEmail: payload.userEmail,
        }),
      })) as MatchRow;

      return mapMatch(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["matches"] });
    },
  });
};
